// @flow
// Réserver le retour: crée une nouvelle course inversée (arrivée → départ)
// à J+2, avec estimation, puis redirige vers l'édition.
// Logique extraite de l'ancien Header/TopButtons/BookingWayBackBtn pour
// être appelée depuis le menu d'actions (DDL manager).

import moment from "moment";

import { getDirections } from "../../components/Map/mapbox";
import history from "../../history";
import Api from "../../components/Api";

export default function bookingWayBack(ride: Object, user: ?Object) {
	const newRide = {};

	const departurePoint = {
		latitude: ride.arrival_latitude,
		longitude: ride.arrival_longitude,
	};
	const arrivalPoint = {
		latitude: ride.departure_latitude,
		longitude: ride.departure_longitude,
	};

	const departure_date = moment().add(2, "d").toISOString();

	getDirections(departurePoint, arrivalPoint, null, [], ride.service, async function (err, result) {
		if (!err) {
			newRide.waypoints = result.waypoints;
			newRide.duration = result.duration;
			newRide.distance = result.distance;

			// Estimation
			let url = "estimation?departure_date=" + departure_date;
			url += `&distance=${newRide.distance}`;
			url += `&driver_group=${ride.driver_group._id}`;
			url += `&duration=${newRide.duration}`;
			url += `&service=${ride.service}`;
			url += `&departure_latitude=${ride.arrival_latitude}`;
			url += `&departure_longitude=${ride.arrival_longitude}`;
			url += `&arrival_latitude=${ride.departure_latitude}`;
			url += `&arrival_longitude=${ride.departure_longitude}`;
			url += `&stops=${ride.stops && ride.stops.length > 0}`;

			if (ride.business_group) {
				url += `&business_group=${ride.business_group._id}`;
			}

			const resQuotation = await Api.get(url);
			newRide.low_estimate = resQuotation.data.low_estimate;
			newRide.high_estimate = resQuotation.data.high_estimate;

			newRide.price_client = resQuotation.data.price_client || null;
			newRide.price_sc = resQuotation.data.price_subcontractor || null;
			newRide.catalogue = resQuotation.data.catalogue || null;

			// Get previous ride informations
			newRide.departure_address = ride.arrival_address;
			newRide.departure_latitude = ride.arrival_latitude;
			newRide.departure_longitude = ride.arrival_longitude;
			newRide.arrival_address = ride.departure_address;
			newRide.arrival_latitude = ride.departure_latitude;
			newRide.arrival_longitude = ride.departure_longitude;
			newRide.business_group = ride.business_group ? ride.business_group._id : null;
			newRide.business_unit = ride.business_unit ? ride.business_unit._id : null;
			newRide.invited = ride.invited;
			newRide.notify_passenger = ride.notify_passenger;
			newRide.comment_public = ride.comment_public;
			newRide.comment_private = ride.comment_private;
			newRide.driver_unit = null;
			newRide.driver_group = ride.driver_group._id;
			newRide.departure_date = departure_date;
			newRide.nb_passenger = ride.nb_passenger;
			newRide.service = ride.service;
			newRide.passenger = ride.passenger._id;
			newRide.status = "TO_BE_ASSIGNED";

			// Create new ride
			const res = await Api.post("rides", newRide);
			const { data } = res;

			// Redirect
			if (user && user.roles.includes("business")) {
				history.push(`/business/rides/edit/${data._id}`);
			} else if (user && user.roles.includes("manager")) {
				history.push(`/manager/rides/edit/${data._id}`);
			} else if (user) {
				history.push(`/operator/rides/edit/${data._id}`);
			}
		}
		return false;
	});
}
